import { useState, useRef, useEffect } from "react";
import styles from "./css/InputBox.module.css";

interface InputBoxProps {
  onSendMessage: (message: string) => void;
}

export default function InputBox({ onSendMessage }: InputBoxProps) {
  const [message, setMessage] = useState("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const adjustHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto"; // 높이 초기화
      const lineHeight = 20; // 한 줄의 높이
      const maxHeight = lineHeight * 4; // 최대 4줄
      const scrollHeight = textarea.scrollHeight;

      textarea.style.height = `${Math.max(
        lineHeight,
        Math.min(scrollHeight - 18, maxHeight)
      )}px`;
    }
  };

  useEffect(() => {
    adjustHeight();
  }, [message]);

  const handleSubmit = () => {
    if (message.trim()) {
      onSendMessage(message);
      setMessage("");
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <div className={styles.inputContainer}>
      <textarea
        id="message"
        ref={textareaRef}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyPress={handleKeyPress}
        maxLength={255}
        placeholder="메시지를 입력하세요"
        className={styles.input}
      />
      <button
        id="send"
        onClick={handleSubmit}
        disabled={!message.trim()}
        className={styles.sendButton}
      >
        전송
      </button>
    </div>
  );
}
